import mcvLockup from '~/assets/logo-mcv-header.png';
import mcvIcon from '~/assets/logo-mcv-mark.png';

interface Props {
  // `icon`/`none` render the square vault mark; `side`/`above` render the full
  // horizontal "MedCredVault" lockup. Sized by `height`; width follows the
  // artwork's aspect ratio.
  label?: 'side' | 'above' | 'icon' | 'none';
  height?: number;
}

export const McvLogo = ({ label = 'side', height = 32 }: Props) => {
  const iconOnly = label === 'icon' || label === 'none';
  const src = iconOnly ? mcvIcon : mcvLockup;

  return <img src={src} alt="MedCredVault" style={{ height }} className="w-auto" />;
};
